import { render, staticRenderFns } from "./keyboard.vue?vue&type=template&id=05f78038&scoped=true"
import script from "./keyboard.vue?vue&type=script&lang=js"
export * from "./keyboard.vue?vue&type=script&lang=js"
import style0 from "./keyboard.vue?vue&type=style&index=0&id=05f78038&prod&lang=css"
import style1 from "./keyboard.vue?vue&type=style&index=1&id=05f78038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f78038",
  null
  
)

export default component.exports